import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '..';
import { getBearingEnvelopeInsertionSettings } from '../slices/layoutSlice';
import { getInsertingObjectInfo } from './insertionObjectSelectors';

export const getInsertingBearingEnvelopeSettingsOrNull = createSelector(
  getInsertingObjectInfo,
  (state: RootState) => state.layout.bearingEnvelopeInsertionSettings,

  (
    insertingObjectInfo,
    bearingEnvelopeInsertionSettings,
  ): ReturnType<typeof getBearingEnvelopeInsertionSettings> | null => {
    if (insertingObjectInfo?.type !== 'bearingEnvelope') return null;

    return getBearingEnvelopeInsertionSettings(
      { bearingEnvelopeInsertionSettings },
      insertingObjectInfo.data.bearingType,
    );
  },
);
